// Dependency
import axios from 'axios';
const domain = process.env.REACT_APP_DOMAIN || 'https://nxgn-studios.herokuapp.com';

// Set Base for all API calls in this file
const staffAPI = axios.create({
  baseURL: domain,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

// Get All
export const GetStaff = async () => {
  try {
    const data = await staffAPI.get('/api/staff')
    .then(res => {
      return res.data;
    })
    return data;
  }
  catch(err) {
    console.log(err);
  }
};

// Get By ID
export const GetOneStaff = async (id) => {
  try {
    const data = await staffAPI.get(`/api/staff/${id}`)
    .then(res => {
      return res.data;
    })
    return data;
  }
  catch(err) {
    console.log(err);
  }
};

// Get List of Classes
export const GetClasses = async (id) => {
  try {
    const data = await staffAPI.get(`/api/staff/${id}/classes`)
    .then(res => {
      return res.data;
    })
    return data;
  }
  catch(err) {
    console.log(err);
  }
};

export default { GetStaff, GetOneStaff, GetClasses };